interface GetGiftcardAmountSubtitleParams {
  giftcard: AdaptedGiftcard;
  subtitles: GiftcardsPagesLayoutContent['subtitles'];
}

export const getGiftcardAmountSubtitle = (
  params: GetGiftcardAmountSubtitleParams,
) => {
  const { giftcard, subtitles } = params;

  if (!giftcard || !subtitles) return '';

  if (!giftcard.isActivated) return subtitles.mustBeActivated;

  if (giftcard.isExpired) {
    const depreciations = giftcard.transactions.filter(
      transaction => transaction.type === 'DEPRECIATION',
    );

    const lastDepreciation = depreciations.at(-1);

    return subtitles.expiredAt.replace(
      '<<confirmedAt>>',
      lastDepreciation?.formatted.confirmedAt || '',
    );
  }

  const creditTransactions = giftcard.transactions.filter(
    transaction => transaction.type === 'CREDIT',
  );

  const lastCreditTransaction = creditTransactions.at(-1);

  return subtitles.balance.replace(
    '<<confirmedAt>>',
    lastCreditTransaction?.formatted.confirmedAt || '',
  );
};
